import httpWrapper from '../HttpWrapper'
import {
    GetNetworkScopedReq,
    GetNetworkScopedRes,
} from './models/getNetworkScopedDtos'
import { WorkedWithRelationshipsInfo } from './models/WorkedWithRelationshipsInfo'
import {
    GenerateNetworkReq,
    GenerateNetworkRes,
} from './models/generateNetwork/GenerateNetworkDtos'
import {
    QueueNetworkImportReq,
    QueueNetworkImportRes,
} from './models/queueNetworkImport/QueueNetworkImportDtos'
import { BackfillRelationshipScoresRes } from './models/BackfillRelationshipScoresDtos'
import {
    GetPersonNetworkReq,
    GetPersonNetworkRes,
} from './models/getPersonNetworkDtos'
import {
    FindConnectionsByNamesReq,
    FindConnectionsByNamesRes,
} from './models/findConnectionsByNamesDtos'

class NetworkApi {
    private static instance: NetworkApi

    public constructor() {
        if (NetworkApi.instance) {
            return NetworkApi.instance
        }

        NetworkApi.instance = this
    }

    public async getWorkedWithRelationshipsInfo(): Promise<WorkedWithRelationshipsInfo> {
        return await httpWrapper.get<WorkedWithRelationshipsInfo>(
            '/network/worked-with-relationships-info',
        )
    }

    public async deleteWorkedWithRelationships(): Promise<void> {
        return await httpWrapper.post('network/delete/all-worked-with')
    }

    public async createWorkedWithRelationships(): Promise<void> {
        return await httpWrapper.post('network/create/all-worked-with')
    }

    public async backfillRelationshipScores(): Promise<BackfillRelationshipScoresRes> {
        return await httpWrapper.post<undefined, BackfillRelationshipScoresRes>(
            'network/backfill-relationship-scores',
        )
    }

    public async generateNetwork(
        req: GenerateNetworkReq,
    ): Promise<GenerateNetworkRes> {
        return await httpWrapper.post<GenerateNetworkReq, GenerateNetworkRes>(
            'network/generate',
            req,
        )
    }

    public async queueNetworkImport(
        req: QueueNetworkImportReq,
        isProductAdmin?: boolean,
    ): Promise<QueueNetworkImportRes> {
        const endpoint = isProductAdmin
            ? 'network/queue-import-admin'
            : 'network/queue-import'
        return await httpWrapper.post<
            QueueNetworkImportReq,
            QueueNetworkImportRes
        >(endpoint, req)
    }

    public async getNetworkScoped(
        req: GetNetworkScopedReq,
    ): Promise<GetNetworkScopedRes> {
        return await httpWrapper.post('network/get-network-scoped', req)
    }

    public async getPersonNetwork(
        req: GetPersonNetworkReq,
    ): Promise<GetPersonNetworkRes> {
        return await httpWrapper.post('network/get-person-network', req)
    }

    public async findConnectionsByNames(
        req: FindConnectionsByNamesReq,
    ): Promise<FindConnectionsByNamesRes> {
        return await httpWrapper.post<
            FindConnectionsByNamesReq,
            FindConnectionsByNamesRes
        >('network/find-connections-by-names', req)
    }
}

const networkApi = new NetworkApi()
export default networkApi
